<template>
	<b-modal
		v-model="internetDisconnected"
		id="internet-disconnect-modal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
	>
		<div
			:class="[
				isLaptop
					? 'internet-disconnected-modal-content'
					: 'mobile-modal-content',
				'd-flex flex-column align-items-center justify-content-center',
			]"
		>
			<div
				:class="
					isLaptop
						? 'newmodalheadings mt-3'
						: 'mobileScreen-TD-head mt-4 text-center'
				"
			>
				Slow or Unstable Internet Connection
			</div>

			<div class="mt-3">
				<svg
					width="132"
					height="131"
					viewBox="0 0 132 131"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M66.0003 92.8124C69.0132 92.8124 71.4557 95.2548 71.4557 98.2678C71.4557 101.281 69.0132 103.723 66.0003 103.723C62.9874 103.723 60.5449 101.281 60.5449 98.2678C60.5449 95.2548 62.9874 92.8124 66.0003 92.8124Z"
						fill="#4C78CE"
					/>
					<path
						d="M110.688 56.0666C105.75 49.0146 99.2131 43.2311 91.6115 39.1894C84.0105 35.1476 75.5601 32.9623 66.9526 32.812C58.3446 32.6618 49.8233 34.5509 42.0855 38.3249C34.3476 42.0989 27.6128 47.6507 22.4316 54.5262M97.2818 70.9096C93.8253 65.973 89.2493 61.9246 83.9282 59.0954C78.6075 56.2662 72.6923 54.736 66.6668 54.6313C60.6413 54.5259 54.6764 55.8484 49.2599 58.4899C43.8434 61.1319 39.129 65.0183 35.5022 69.8311M79.4067 83.4259C77.9251 81.3103 75.9644 79.5749 73.6835 78.3627C71.4031 77.15 68.868 76.4943 66.286 76.4495C63.7034 76.4042 61.147 76.9711 58.8258 78.103C56.5045 79.2356 54.484 80.9011 52.9297 82.9638"
						stroke="#4C78CE"
						stroke-width="10.9108"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<rect
						x="26.8574"
						y="24.8892"
						width="13.4041"
						height="101.808"
						rx="6.70204"
						transform="rotate(-42.1739 26.8574 24.8892)"
						fill="#4C78CE"
						stroke="white"
						stroke-width="5"
					/>
				</svg>
			</div>

			<div
				:class="[
					isLaptop
						? 'newmodal-body-content mt-4 mb-4 text-center'
						: 'mobileScreen-TD-body-subhead mt-3 text-center',
				]"
			>
				{{
					isVideoResume
						? "Your internet connection is slow. Please check your connection to restart the process."
						: "Your internet connection is slow. Please check your connection and reopen the link to restart the process."
				}}
			</div>

			<div
				:class="[
					'd-flex align-items-center justify-content-center',
					isLaptop ? 'okay-button mt-4' : 'mt-3 w-100',
				]"
			>
				<b-button
					class="candash-addBtn"
					:class="isLaptop ? '' : 'w-50'"
					@click="closemodal"
				>
					Okay
				</b-button>
			</div>
		</div>
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			internetDisconnected: false,
			isLaptop: true,
			isVideoResume: false,
		};
	},
	mounted() {
		window.addEventListener("resize", this.checkScreenSize);
		this.checkScreenSize();

		window.addEventListener("trigger-internet-disconnected", (event) => {
			if (event.detail && event.detail.isResumeVideo) {
				this.isVideoResume = true;
			}
			this.internetDisconnected = true;
		});
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		closemodal() {
			const uuid = sessionStorage.getItem("verificationUUID");
			console.log("the uuid is", uuid);
			if (uuid) {
				this.$router.replace({
					name: "IdCapture",
					query: {
						uuid: uuid,
						refresh: "true",
					},
				});
			} else {
				this.$router.go(-1);
			}
		},
	},
};
</script>
<style>
#internet-disconnect-modal .modal-dialog {
	max-width: 633px;
}

.mobile-modal-content {
	border-radius: 12px;
	background: #fff;
	width: 100%;
	max-width: 400px;
	padding: 0px;
}

.testscreen-custom-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(
		0,
		0,
		0,
		0.5
	); /* Semi-transparent background overlay */
	z-index: 1500;
}
.testscreen-modal-content {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 4px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	max-width: 50%;
	max-height: 80%;
	overflow: auto;
	padding: 10px;
	position: relative;
	width: 650px;
}
.internet-disconnected-modal-content {
	border-radius: 18.743px;
	background: #fff;
	height: fit-content;
	overflow: auto;
	padding: 0px;
	position: relative;
}

.mobileScreen-TD-head {
	color: #424242;
	font-size: 18px;
	font-weight: 600;
}

.mobileScreen-TD-body-subhead {
	color: #667085;
	font-size: 16px;
	font-weight: 400;
}

.newmodalheadings {
	color: #333;
	font-family: "Product Sans", sans-serif;
	font-size: 30px;
	font-weight: 400;
}
</style>
